export enum WebhookEventType {
  CallCompleted = "call_processed",
  CallFailed = "call_failed",
  ConversationStarted = "conversation_started",
  ConversationUpdated = "conversation_updated",
  ConversationFinished = "conversation_finished",
  ChatConversationStarted = "chat_conversation_started",
  ChatConversationUpdated = "chat_conversation_updated",
}

export enum DaysOfWeek {
  Sunday = "sunday",
  Monday = "monday",
  Tuesday = "tuesday",
  Wednesday = "wednesday",
  Thursday = "thursday",
  Friday = "friday",
  Saturday = "saturday",
}
